import { Injectable } from '@angular/core';
import { AbstractDialogService } from '@examdojo/core/dialog';
import { SubmitConfirmationDialogComponent } from './submit-confirmation-dialog.component';

@Injectable()
export class SubmitConfirmationDialogService extends AbstractDialogService<void, boolean> {
  readonly id = 'submit-confirmation-dialog';
  protected override readonly options = {
    cssClass: 'submit-confirmation-dialog auto-height action-sheet-on-mobile',
  };
  protected override readonly component = SubmitConfirmationDialogComponent;
}
